<div class="title">Designer pieces for your budget</div>
<div class="box-budget">
  <a routerLink="/sale" [queryParams]="{ price: budget[appConfig['currencyCode'] ?? 'EUR'][0]['param'] }">
    <div
      class="half-image"
      lazyLoad="{{ env.UPLOADS_IMGIX_URL }}/static/home/under50.JPG"
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
    >
      <span class="text">
        {{ budget[appConfig['currencyCode'] ?? 'EUR'][0]['label'] }}
      </span>
    </div>
  </a>
  <a routerLink="/sale" [queryParams]="{ price: budget[appConfig['currencyCode'] ?? 'EUR'][1]['param'] }">
    <div
      class="half-image"
      lazyLoad="{{ env.UPLOADS_IMGIX_URL }}/static/home/50-300.jpg"
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
    >
      <span class="text">
        {{ budget[appConfig['currencyCode'] ?? 'EUR'][1]['label'] }}
      </span>
    </div>
  </a>
  <ng-container *ngIf="isMobile$?.value">
    <a routerLink="/sale" [queryParams]="{ price: budget[appConfig['currencyCode'] ?? 'EUR'][2]['param'] }">
      <div
        class="half-image"
        lazyLoad="{{ env.UPLOADS_IMGIX_URL }}/static/home/300-500.jpg"
        [defaultImage]="'assets/images/placeholder.png'"
        [errorImage]="'assets/images/placeholder.png'"
      >
        <span class="text">
          {{ budget[appConfig['currencyCode'] ?? 'EUR'][2]['label'] }}
        </span>
      </div>
    </a>
    <a routerLink="/sale" [queryParams]="{ price: budget[appConfig['currencyCode'] ?? 'EUR'][3]['param'] }">
      <div
        class="half-image"
        lazyLoad="{{ env.UPLOADS_IMGIX_URL }}/static/home/500-1000.JPG"
        [defaultImage]="'assets/images/placeholder.png'"
        [errorImage]="'assets/images/placeholder.png'"
      >
        <span class="text">
          {{ budget[appConfig['currencyCode'] ?? 'EUR'][3]['label'] }}
        </span>
      </div>
    </a>
  </ng-container>
  <a routerLink="/sale" [queryParams]="{ price: budget[appConfig['currencyCode'] ?? 'EUR'][4]['param'] }">
    <div
      class="full-image"
      lazyLoad="{{ env.UPLOADS_IMGIX_URL }}/static/home/Exclusives.JPG"
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
    >
      <span class="text">
        {{ budget[appConfig['currencyCode'] ?? 'EUR'][4]['label'] }}
      </span>
    </div>
  </a>
</div>
<ng-container *ngIf="!isMobile$?.value">
  <div class="box-budget bottom">
    <a routerLink="/sale" [queryParams]="{ price: budget[appConfig['currencyCode'] ?? 'EUR'][2]['param'] }">
      <div
        class="half-image"
        lazyLoad="{{ env.UPLOADS_IMGIX_URL }}/static/home/300-500.jpg"
        [defaultImage]="'assets/images/placeholder.png'"
        [errorImage]="'assets/images/placeholder.png'"
      >
        <span class="text">
          {{ budget[appConfig['currencyCode'] ?? 'EUR'][2]['label'] }}
        </span>
      </div>
    </a>
    <a routerLink="/sale" [queryParams]="{ price: budget[appConfig['currencyCode'] ?? 'EUR'][3]['param'] }">
      <div
        class="half-image"
        lazyLoad="{{ env.UPLOADS_IMGIX_URL }}/static/home/500-1000.JPG"
        [defaultImage]="'assets/images/placeholder.png'"
        [errorImage]="'assets/images/placeholder.png'"
      >
        <span class="text">
          {{ budget[appConfig['currencyCode'] ?? 'EUR'][3]['label'] }}
        </span>
      </div>
    </a>
  </div>
</ng-container>
